export const formatScore = (score: number): string => {
    if (score <= 0) {
        return '-';
    }
    return score % 1 === 0 ? String(score) : score.toFixed(1);
};

// Colour modifier for the `.rating-pill` component (styles/components/_rating-pill.scss).
// Scores run 0-10; anything at or below 0 means "not rated yet".
export const ratingPillModifier = (score: number): string => {
    if (score <= 0) {
        return 'rating-pill--empty';
    }
    if (score < 5) {
        return 'rating-pill--red';
    }
    if (score < 7) {
        return 'rating-pill--orange';
    }
    return 'rating-pill--green';
};
